"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3056],{

/***/ 73056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FooterBarA": function() { return /* reexport */ FooterBarA; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/styles/useTheme/index.js
var useTheme = __webpack_require__(48678);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(21122);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var styles_useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/FooterBarA/@editor/index.tsx


var useEditorHandlers = function(name) {
    var theme = (0,styles_useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_footer_bar_color",
                label: "Text color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_footer_bar_link_color",
                label: "Link color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_footer_bar_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.primary.main
            },
            {
                name: "theme_component_footer_bar_background_image",
                label: "Background image",
                type: "text",
                startAdornment: "url(https://",
                endAdornment: "/)"
            },
            {
                name: "theme_component_footer_bar_background_position",
                label: "Background position",
                type: "select",
                default: "center",
                options: [
                    "top",
                    "right",
                    "bottom",
                    "left",
                    "center"
                ]
            },
            {
                name: "theme_component_footer_bar_background_size",
                label: "Background size",
                type: "select",
                default: "cover",
                options: [
                    "cover",
                    "contain",
                    "initial",
                    "inherit",
                    "auto"
                ]
            },
            {
                name: "theme_component_footer_bar_background_repeat",
                label: "Background repeat",
                type: "select",
                default: "no-repeat",
                options: [
                    "no-repeat",
                    "repeat-y",
                    "repeat-x",
                    "repeat"
                ]
            }, 
        ],
        configuration: [
            {
                name: "component_footer_bar_azerion_footer",
                label: "Azerion branded footer visible",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_privacy_url_disabled",
                label: "Privacy statement URL disabled",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_privacy_url",
                label: "Privacy statement URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                name: "component_footer_bar_privacy_url",
                label: "Privacy statement URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                name: "component_footer_bar_terms_url_disabled",
                label: "Terms and agreements URL disabled",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_terms_url",
                label: "Terms and agreements URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                name: "component_footer_bar_cookies_url_disabled",
                label: "Cookie statement URL disabled",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_cookies_url",
                label: "Cookie statement URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                name: "component_footer_bar_help_center_url_disabled",
                label: "Help center URL disabled",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_help_center_url",
                label: "Help center URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                name: "component_footer_bar_contact_url_disabled",
                label: "Contact URL disabled",
                type: "checkbox",
                default: false
            },
            {
                name: "component_advertisement_show",
                label: "Show Sticky Advertisement",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_contact_url",
                label: "Contact URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Colophon"
            },
            {
                name: "component_footer_bar_colophon_text",
                label: "Colophon text",
                type: "text",
                helperText: "The small text at the bottom of the footer, e.g. the copyright text."
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Social links"
            },
            {
                name: "component_footer_bar_twitch_url",
                label: "Twitch URL",
                type: "text"
            },
            {
                name: "component_footer_bar_youtube_url",
                label: "Youtube URL",
                type: "text"
            },
            {
                name: "component_footer_bar_instagram_url",
                label: "Instagram URL",
                type: "text"
            },
            {
                name: "component_footer_bar_twitter_url",
                label: "Twitter URL",
                type: "text"
            },
            {
                name: "component_footer_bar_facebook_url",
                label: "Facebook URL",
                type: "text"
            },
            {
                name: "component_footer_bar_tiktok_url",
                label: "TikTok URL",
                type: "text"
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/facebook.js


/* harmony default export */ function facebook(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: color,
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M32 16c0-8.836-7.164-16-16-16S0 7.164 0 16s7.164 16 16 16 16-7.164 16-16zm-20.297 0v-3.062h1.877v-1.851c0-2.498.746-4.297 3.48-4.297h3.253v3.054h-2.29c-1.147 0-1.408.763-1.408 1.561v1.533h3.529L19.663 16h-3.048v9.235H13.58V16h-1.877z",
                        transform: "translate(-1677.000000, -3543.000000) translate(1677.000000, 3543.000000)"
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/youtube.js


/* harmony default export */ function youtube(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: color,
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm8 16.6c0 1.3-.2 2.6-.2 2.6s-.2 1.1-.6 1.6c-.6.6-1.3.6-1.6.7-2.2.2-5.6.2-5.6.2s-4.2 0-5.4-.2c-.4-.1-1.2 0-1.8-.7-.5-.5-.6-1.6-.6-1.6S8 17.9 8 16.6v-1.2c0-1.3.2-2.6.2-2.6s.2-1.1.6-1.6c.6-.6 1.3-.6 1.6-.7 2.2-.2 5.6-.2 5.6-.2s3.4 0 5.6.2c.3 0 1 0 1.6.7.5.5.6 1.6.6 1.6s.2 1.3.2 2.6v1.2z",
                                transform: "translate(-1729.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(52.000000, 0.000000)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M14.3 18.1L18.7 15.8 14.3 13.6z",
                                transform: "translate(-1729.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(52.000000, 0.000000)"
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/twitter.js


/* harmony default export */ function twitter(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: color,
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm5.178-18.687v.001c.414-.273.969-.838 1.1-1.393-.41.279-.897.423-1.393.413.565-.272.979-.686 1.12-1.393-.545.292-.959.565-1.665.707-1.535-1.828-5.18-.415-4.474 2.373-2.534-.132-4.07-1.395-5.322-2.788-.696 1.12-.14 2.938.84 3.494-.567 0-.85-.131-1.122-.273 0 1.394.848 2.232 1.97 2.656H11.11c.415.96 1.121 1.666 2.373 1.666-.828.848-2.514 1.262-3.766 1.12 1.12.839 2.373 1.394 4.2 1.253 4.322-.142 7.26-3.363 7.26-7.836h.001z",
                            transform: "translate(-1781.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(104.000000, 0.000000)"
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/instagram.js


/* harmony default export */ function instagram(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: color,
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M12.9 16c0 1.712 1.388 3.1 3.1 3.1 1.712 0 3.1-1.388 3.1-3.1 0-1.108-.59-2.13-1.55-2.685-.96-.553-2.14-.553-3.1 0-.96.554-1.55 1.577-1.55 2.685zM19.6 12.9h2.2c.2 0 .4-.2.4-.4v-2.2c0-.2-.2-.4-.4-.4h-2.2c-.2 0-.4.2-.4.4v2.2c-.1.2.1.4.4.4z",
                                transform: "translate(-1833.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(156.000000, 0.000000)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm8 22.1c0 1-.9 1.9-1.9 1.9H9.9c-1 0-1.9-.8-1.9-1.9V9.9C8 8.8 8.9 8 9.9 8h12.2c1 0 1.9.8 1.9 1.9v12.2z",
                                transform: "translate(-1833.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(156.000000, 0.000000)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M20.9 16c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9c0-.4.1-.9.2-1.3H9.8v7c0 .2.2.4.4.4h11.5c.2 0 .4-.2.4-.4v-7h-1.5c.2.4.3.9.3 1.3z",
                                transform: "translate(-1833.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(156.000000, 0.000000)"
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/tiktok.js




/* harmony default export */ function tiktok(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "32",
        height: "32",
        x: "0",
        y: "0",
        viewBox: "0 0 512 512",
        className: className,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            enableBackground: "new 0 0 512 512"
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                xmlns: "http://www.w3.org/2000/svg",
                d: "m256 0c-141.363 0-256 114.637-256 256s114.637 256 256 256 256-114.637 256-256-114.637-256-256-256zm128.43 195.873v34.663c-16.345.006-32.226-3.197-47.204-9.516-9.631-4.066-18.604-9.305-26.811-15.636l.246 106.693c-.103 24.025-9.608 46.598-26.811 63.601-14 13.84-31.74 22.641-50.968 25.49-4.518.669-9.116 1.012-13.766 1.012-20.583 0-40.124-6.668-56.109-18.97-3.008-2.316-5.885-4.827-8.624-7.532-18.644-18.427-28.258-43.401-26.639-69.674 1.235-19.999 9.242-39.072 22.59-54.021 17.66-19.782 42.366-30.762 68.782-30.762 4.65 0 9.248.349 13.766 1.018v12.816 35.652c-4.284-1.413-8.859-2.19-13.623-2.19-24.134 0-43.659 19.69-43.298 43.842.229 15.453 8.67 28.961 21.12 36.407 5.851 3.5 12.582 5.668 19.765 6.062 5.628.309 11.032-.475 16.036-2.127 17.243-5.696 29.682-21.892 29.682-40.994l.057-71.447v-130.44h47.736c.046 4.73.526 9.345 1.418 13.817 3.603 18.101 13.806 33.805 28.006 44.511 12.382 9.339 27.8 14.875 44.511 14.875.011 0 .149 0 .137-.011v12.861z",
                fill: color
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/twitch.js


/* harmony default export */ function twitch(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        className: className,
        style: style,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                transform: "translate(-1545.000000, -2868.000000)",
                fill: color,
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    transform: "translate(1545.000000, 2868.000000)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M13.632,23.7413333 L16,21.3733333 L20.4573333,21.3733333 L23.244,18.5866667 L23.244,9.672 L9.87066667,9.672 L9.87066667,21.3733333 L13.632,21.3733333 L13.632,23.7413333 Z M18.7866667,12.876 L20.4586667,12.876 L20.4586667,17.7466667 L18.7866667,17.7466667 L18.7866667,12.876 Z M14.328,12.876 L16,12.876 L16,17.7466667 L14.328,17.7466667 L14.328,12.876 Z M16,0 C7.164,0 0,7.164 0,16 C0,24.836 7.164,32 16,32 C24.836,32 32,24.836 32,16 C32,7.164 24.836,0 16,0 Z M24.916,19.4226667 L20.04,24.2986667 L16.4186667,24.2986667 L14.0493333,26.6666667 L11.5426667,26.6666667 L11.5426667,24.2986667 L7.084,24.2986667 L7.084,11.204 L8.33866667,8 L24.916,8 L24.916,19.4226667 L24.916,19.4226667 Z"
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/icons/sbtgames.js


/* harmony default export */ function sbtgames(param) {
    var _color = param.color, color = _color === void 0 ? "#fff" : _color, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                transform: "translate(-1733.000000, -2868.000000)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    transform: "translate(1545.000000, 2868.000000)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(188.000000, 0.000000)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: color,
                                fillRule: "nonzero",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M16.5034633,0 C18.3120278,0.076875 20.1130878,0.425625 21.7984548,1.090625 C25.2010825,2.4075 28.1177991,4.930625 29.910104,8.1075 C32.3934406,12.385625 32.6748563,17.838125 30.6943156,22.365 C28.9745534,26.36625 25.5431588,29.59625 21.4344906,31.051875 C19.8554362,31.63 18.183202,31.93125 16.5047141,32 L15.5416473,32 C12.6955972,31.905 9.87581255,31.059375 7.46939622,29.533125 C4.3713228,27.58125 1.96990942,24.544375 0.821733643,21.065625 C0.303303514,19.524375 0.0343952438,17.90375 0,16.279375 L0,15.72375 C0.0575338624,11.755625 1.67160885,7.840625 4.42010151,4.9775 C5.36503267,3.950625 6.47005804,3.07625 7.65888274,2.34625 C10.0590454,0.865 12.8606943,0.0625 15.6786029,0 L16.5034633,0 Z M11.4423596,5.068125 C11.3047786,5.053125 11.1809557,5.170625 11.2028436,5.310625 L11.2022182,16.0025 L11.2022182,16.0025 C11.2015929,16.88875 11.2447433,17.788125 11.4967666,18.64375 C11.6649906,19.223125 11.9507838,19.7675 12.3310076,20.23625 C13.1164699,21.255625 14.2646457,21.9775 15.5153818,22.273125 C16.7823775,22.5875 18.1556858,22.438125 19.3320031,21.875625 C20.626515,21.265625 21.6702543,20.15125 22.204944,18.82625 C22.6083064,17.840625 22.7214981,16.738125 22.522631,15.691875 C22.2718584,14.32875 21.5020303,13.075625 20.4188928,12.214375 C19.4927227,11.470625 18.3239098,11.02625 17.1338344,11.00375 C16.0131748,10.97625 14.8931406,11.34125 13.9901091,12 L13.9901091,5.309375 C14.0076194,5.18125 13.8963039,5.05625 13.7649766,5.069375 C12.9907709,5.064375 12.2165652,5.06616663 11.4423596,5.068125 Z M5.59516812,10.920625 C4.39133458,11.105625 3.20376062,11.799375 2.67782607,12.93375 C2.2719622,13.811875 2.23006254,14.86875 2.60153117,15.765625 C2.96236854,16.61 3.7740963,17.153125 4.60583583,17.469375 C5.43132168,17.85125 6.38188115,17.910625 7.15858829,18.405625 C7.39435205,18.60375 7.38121932,18.97375 7.29116632,19.24125 C7.12419305,19.65875 6.643285,19.810625 6.23304355,19.851875 L5.94691558,19.8657476 C4.90062739,19.8818967 3.88634987,19.5263542 2.92672256,19.135625 C2.8910071,19.114375 2.84997987,19.1005015 2.8076693,19.0941692 L2.7437445,19.0903472 C2.61598412,19.0940972 2.49480168,19.1664583 2.48896492,19.311875 C2.47583219,20.0625 2.48521271,20.81375 2.48396197,21.564375 C2.47270535,21.799375 2.75537171,21.819375 2.91796741,21.885625 C3.84559671,22.2164583 4.83909812,22.4311806 5.82768923,22.425162 L6.12404847,22.4166296 C6.51880896,22.3961444 6.91165128,22.3386667 7.29804537,22.2375 C8.27424492,21.98625 9.17477494,21.360625 9.6456771,20.45625 C10.1190807,19.561875 10.2060069,18.460625 9.85955298,17.508125 C9.57000756,16.710625 8.9189994,16.061875 8.131661,15.75125 C7.33369135,15.40875 6.47068341,15.265 5.65707955,14.969375 C5.4388261,14.885 5.19243108,14.773125 5.10300345,14.54 C4.99669087,14.20625 5.1567851,13.824375 5.44445441,13.634375 C5.7305603,13.4407812 6.07189401,13.37375 6.41305184,13.3578711 L6.58335959,13.3538452 C6.63995296,13.3536914 6.69628494,13.3546094 6.75209904,13.35625 C7.45376202,13.4025 8.13603858,13.59625 8.79705263,13.82625 C8.9465156,13.873125 9.09160099,13.95625 9.25169522,13.954375 L9.30707037,13.9334876 C9.40469343,13.8767347 9.42644092,13.7366071 9.4242968,13.63 C9.42304607,12.921875 9.42929975,12.213125 9.42116996,11.505625 C9.41991923,11.3675 9.25419669,11.341875 9.15476317,11.29875 C8.42927935,11.0597159 7.66935378,10.8963585 6.90480068,10.8571577 L6.57693866,10.8481001 C6.24896717,10.8469267 5.92092803,10.8698295 5.59516812,10.920625 Z M24.6351244,7.473125 C24.5156791,7.45625 24.4137441,7.569375 24.4256261,7.685 C24.4181216,8.76625 24.4237499,9.8475 24.4224992,10.92875 L23.8678209,10.9295139 C23.4980662,10.9282639 23.1284042,10.925625 22.7590201,10.934375 C22.6351973,10.93875 22.5614038,11.064375 22.5739112,11.178125 C22.5726605,11.933125 22.5720351,12.688125 22.5745366,13.4425 C22.558277,13.55625 22.6414509,13.676875 22.762147,13.675 L22.762147,13.675 L23.5917759,13.6797656 L23.5917759,13.6797656 L24.4218738,13.679375 L24.4218738,13.679375 L24.4231246,17.6875 C24.4275022,18.42875 24.4800331,19.18375 24.7401862,19.885 C24.7617761,19.9445867 24.7850036,20.0034938 24.8098063,20.0616708 L24.7401862,19.885 C25.0785103,20.81875 25.8189461,21.585625 26.7219776,21.99125 C27.4446251,22.3123611 28.2404022,22.4201389 29.0271752,22.4190552 L29.3216327,22.41375 C29.4385765,22.4175 29.5242519,22.300625 29.5186236,22.19 C29.5248773,21.4375 29.5204997,20.685 29.5204997,19.9325 C29.5292549,19.816875 29.4542107,19.68625 29.3278863,19.683125 C28.7825654,19.659375 28.1790852,19.650625 27.7300709,19.295 C27.3385905,18.9425 27.2635463,18.376875 27.2404077,17.879375 C27.2279004,16.479375 27.2385316,15.079375 27.2354048,13.679375 L27.2354048,13.679375 C27.6998448,13.6764583 28.1648407,13.6807639 28.6296513,13.6800694 L29.3266356,13.67375 C29.4742225,13.669375 29.53801,13.505625 29.5211251,13.378125 C29.5167475,12.6275 29.5305056,11.87625 29.5148714,11.12625 C29.5048655,10.975 29.339143,10.93625 29.2153201,10.9425 C28.5555568,10.94 27.8951681,10.9425 27.2354048,10.94125 C27.2347794,9.87625 27.2360302,8.81125 27.2347794,7.745625 C27.2516644,7.61625 27.1659889,7.46375 27.0190274,7.47875 C26.2241846,7.468125 25.4293418,7.48 24.6351244,7.473125 L24.6351244,7.473125 Z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M18.969915,14.60125 C20.0074006,15.6225 20.109961,17.42625 19.2019266,18.56125 C18.6836215,19.23605 17.8591803,19.632138 17.0166729,19.6916705 L16.835964,19.699255 C16.2333794,19.707225 15.6320755,19.541375 15.1370341,19.180625 C14.3622031,18.63125 13.9156903,17.69 13.8869233,16.750625 C13.8494013,15.839375 14.2690232,14.921875 14.9863204,14.3575 C15.4046917,14.020625 15.9249979,13.82125 16.4578115,13.761875 C16.5225371,13.7539286 16.5875307,13.7480708 16.6526597,13.7442816 L16.8483201,13.7390999 C17.6315252,13.7430357 18.4151242,14.0419643 18.969915,14.60125 Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                                transform: "translate(2.346497, 7.471445)"
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/FooterBarA.tsx














// icons"







var LinkWrapper = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var FooterBarA_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1060"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column"
    };
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1061"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        backgroundColor: theme.theme_component_footer_bar_background_color || theme.palette.primary.main,
        backgroundImage: theme.theme_component_footer_bar_background_image ? "url(https://".concat(theme.theme_component_footer_bar_background_image, "/)") : "none",
        backgroundPosition: theme.theme_component_footer_bar_background_position || "center",
        backgroundSize: theme.theme_component_footer_bar_background_size || "cover",
        backgroundRepeat: theme.theme_component_footer_bar_background_repeat || "no-repeat",
        color: theme.theme_component_footer_bar_color || theme.palette.primary.contrastText,
        justifyContent: "space-between",
        outlineOffset: "-2px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        backgroundImage: "none",
        justifyContent: "center",
        alignItems: "center"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("lg"), {
        display: "block",
        alignItems: "left"
    }), _obj;
});
var LinkWrap = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LinkWrapper, {
    target: "e16p1062"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_footer_bar_link_color || theme.palette.primary.contrastText,
        textTransform: "capitalize",
        textDecoration: "none",
        margin: "auto 0"
    };
});
var ColophonTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1063"
})(function(param) {
    var theme = param.theme;
    return {
        margin: "auto 0"
    };
});
var LogoImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "e16p1064"
})(function(param) {
    var theme = param.theme;
    return {
        height: "100% !important",
        minHeight: " 100% !important",
        width: "auto !important",
        minWidth: "auto !important",
        margin: "0 !important"
    };
});
var GameLogoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1065"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        height: 120,
        display: "flex",
        flexDirection: "column"
    }, theme.breakpoints.up("sm"), {
        height: 90
    });
});
var SocialMediaWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1066"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        marginRight: 30,
        marginLeft: 30,
        height: 120
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        height: 90
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        margin: theme.spacing(1),
        justifyContent: "flex-start",
        marginRight: 30,
        marginLeft: 30
    }), (0,_define_property/* default */.Z)(_obj, "display", "flex"), (0,_define_property/* default */.Z)(_obj, "flexWrap", "nowrap"), (0,_define_property/* default */.Z)(_obj, "flexShrink", 0), (0,_define_property/* default */.Z)(_obj, "alignItems", "center"), (0,_define_property/* default */.Z)(_obj, "justifyContent", "flex-end"), _obj;
});
var PrivacyParent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1067"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        justifyContent: "space-between",
        flex: "1"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("lg"), {
        flexDirection: "row"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        flexDirection: "column"
    }), _obj;
});
var PrivacyChildren = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1068"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        textAlign: "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("lg"), {
        justifyContent: "left",
        marginRight: 30,
        marginLeft: 30
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        flexDirection: "column",
        alignItems: " flex-start",
        div: {
            padding: "8px"
        }
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        padding: "1 0 0 1"
    }), _obj;
});
var IconsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p1069"
})(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing("auto", 0, "auto", 0),
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        height: "100%"
    };
});
var PolicyWrap = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p10610"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        marginRight: theme.spacing(4),
        whiteSpace: "nowrap"
    };
});
var LogoImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e16p10611"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        marginLeft: theme.spacing(2.1),
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        minWidth: "300px",
        maxHeight: "60px"
    }, theme.breakpoints.down("lg"), {
        marginLeft: theme.spacing(0),
        img: {}
    });
});
var AzerionBrandContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p10612"
})(function() {
    return {
        backgroundColor: "black",
        color: "white"
    };
});
var AzerionBrandContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16p10613"
})(function() {
    return {
        backgroundColor: "black",
        color: "white",
        marginLeft: 30,
        padding: "10px 0"
    };
});
var FooterBarA = function() {
    var theme = (0,useTheme/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)([
        "footerbar_a"
    ]).t;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref = appContext.useConfig(), url = ref.url, assetUrl = ref.assetUrl, footerLogoId = ref.footerLogoId, componentOptions = ref.componentOptions;
    //const cookie = Package.imports.project?.features?.cookie;
    var privacyUrlDisabled = componentOptions.component_footer_bar_privacy_url_disabled;
    var termsUrlDisabled = componentOptions.component_footer_bar_terms_url_disabled;
    var cookiesUrlDisabled = componentOptions.component_footer_bar_cookies_url_disabled;
    var cookieManagementEnabled = componentOptions.component_footer_bar_cookie_management_enabled;
    var helpCenterUrlDisabled = componentOptions.component_footer_bar_help_center_url_disabled;
    var contactUrlDisabled = componentOptions.component_footer_bar_contact_url_disabled;
    var privacyUrl = componentOptions.component_footer_bar_privacy_url;
    var termsUrl = componentOptions.component_footer_bar_terms_url;
    var cookiesUrl = componentOptions.component_footer_bar_cookies_url;
    var helpCenterUrl = componentOptions.component_footer_bar_help_center_url;
    var contactUrl = componentOptions.component_footer_bar_contact_url;
    var twitchUrl = componentOptions.component_footer_bar_twitch_url;
    var youtubeUrl = componentOptions.component_footer_bar_youtube_url;
    var instagramUrl = componentOptions.component_footer_bar_instagram_url;
    var twitterUrl = componentOptions.component_footer_bar_twitter_url;
    var facebookUrl = componentOptions.component_footer_bar_facebook_url;
    var tiktokUrl = componentOptions.component_footer_bar_tiktok_url;
    var sbtUrl = componentOptions.component_footer_bar_sbt_url;
    var colophonText = componentOptions.component_footer_bar_colophon_text;
    var logoUrl = componentOptions.component_footer_bar_logo_url;
    var logoInner = componentOptions.component_footer_bar_logo_inner_url;
    var azerionBrand = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_footer_bar_azerion_footer;
    var handleCookieClick = function() {
        var ref;
        if ((ref = window.OneTrust) === null || ref === void 0 ? void 0 : ref.ToggleInfoDisplay) {
            var ref1;
            (ref1 = window.OneTrust) === null || ref1 === void 0 ? void 0 : ref1.ToggleInfoDisplay();
        }
    };
    var body1Ref = react.useRef(null);
    var body1Ref2 = react.useRef(null);
    var body1Ref3 = react.useRef(null);
    var body1Ref5 = react.useRef(null);
    var body1Ref6 = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Footer Bar A")), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameLogoWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconsWrapper, {
                            children: footerLogoId && (logoUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                component: FooterBarA_Link,
                                className: "p-0",
                                href: logoUrl,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImage, {
                                    height: "46",
                                    width: "100%",
                                    unoptimized: true,
                                    src: "".concat(assetUrl).concat(footerLogoId, "/"),
                                    alt: "logo-url"
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImageContainer, {
                                component: FooterBarA_Link,
                                href: "/",
                                className: "p-0",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImage, {
                                    loader: function(param) {
                                        var src = param.src;
                                        return src;
                                    },
                                    layout: "fill",
                                    objectFit: "contain",
                                    unoptimized: true,
                                    src: "".concat(assetUrl).concat(footerLogoId, "/"),
                                    alt: "logo-inner-url"
                                })
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrivacyParent, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrivacyChildren, {
                                children: [
                                    !privacyUrlDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                        children: privacyUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            ref: body1Ref,
                                            href: privacyUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("privacy_statement", "Privacy statement"),
                                            children: t("privacy_statement", "Privacy statement")
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            ref: body1Ref,
                                            href: "/legal/privacy-statement",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("privacy_statement", "Privacy statement"),
                                            children: t("privacy_statement", "Privacy statement")
                                        })
                                    }),
                                    !termsUrlDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                        children: termsUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            ref: body1Ref2,
                                            href: termsUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("terms_of_use", "Terms of use"),
                                            children: t("terms_of_use", "Terms of use")
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            ref: body1Ref2,
                                            href: "/legal/terms-of-use",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("terms_of_use", "Terms of use"),
                                            children: t("terms_of_use", "Terms of use")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            !cookiesUrlDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                                children: cookiesUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                                    ref: body1Ref3,
                                                    href: cookiesUrl,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    variant: "body1",
                                                    underline: "hover",
                                                    title: t("footer.cookie_policy", "Cookie Policy"),
                                                    children: t("footer.cookie_policy", "Cookie Policy")
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                                    ref: body1Ref3,
                                                    href: "/legal/cookie-statement",
                                                    variant: "body1",
                                                    underline: "hover",
                                                    title: t("footer.cookie_policy", "Cookie Policy"),
                                                    children: t("footer.cookie_policy", "Cookie Policy")
                                                })
                                            }),
                                            cookieManagementEnabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                                    id: "ot-sdk-btn",
                                                    href: "/",
                                                    onClick: handleCookieClick,
                                                    underline: "hover",
                                                    variant: "body1",
                                                    title: t("cookie_management", "Cookie management"),
                                                    children: t("cookie_management", "Cookie management")
                                                })
                                            })
                                        ]
                                    }),
                                    !helpCenterUrlDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                        children: helpCenterUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            href: helpCenterUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("footer.help_center", "Help Center"),
                                            ref: body1Ref5,
                                            children: t("footer.help_center", "Help Center")
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
                                            passHref: true,
                                            href: "/help-center",
                                            as: "/help-center",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                                ref: body1Ref5,
                                                href: "/help-center",
                                                variant: "body1",
                                                underline: "hover",
                                                title: t("footer.help_center", "Help Center"),
                                                children: t("footer.help_center", "Help Center")
                                            })
                                        })
                                    }),
                                    !contactUrlDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                        children: contactUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            href: contactUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("footer.contact", "Contact"),
                                            ref: body1Ref6,
                                            children: t("footer.contact", "Contact")
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrap, {
                                            ref: body1Ref6,
                                            href: "/contact",
                                            variant: "body1",
                                            underline: "hover",
                                            title: t("footer.contact", "Contact"),
                                            children: t("footer.contact", "Contact")
                                        })
                                    }),
                                    colophonText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PolicyWrap, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColophonTextWrapper, {
                                            children: t("colophon_text", colophonText)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaWrapper, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "my-auto",
                                    children: [
                                        twitchUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: twitchUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "Twitch",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(twitch, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        youtubeUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: youtubeUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "Youtube",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(youtube, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        instagramUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: instagramUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "Instagram",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(instagram, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        twitterUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: twitterUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "Twitter",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(twitter, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        sbtUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: sbtUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "SBT",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sbtgames, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        facebookUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: facebookUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "Facebook",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(facebook, {
                                                style: {
                                                    marginRight: 20
                                                },
                                                className: undefined
                                            })
                                        }),
                                        tiktokUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: tiktokUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "TikTok",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tiktok, {
                                                style: undefined,
                                                className: undefined
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })),
            azerionBrand && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContent, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: "/images/azerion-brand.png",
                        loader: function(param) {
                            var src = param.src, width = param.width;
                            return "".concat(src, "?w=").concat(width || 180);
                        },
                        alt: "made-with-love",
                        height: "30",
                        width: "180"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarA/index.tsx



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);